(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DevisContratController', DevisContratController);

    DevisContratController.$inject = ['$stateParams', '$uibModal', '$window', '$translate', 'entity', 'DevisContrat', 'AlertService', 'Principal'];

    function DevisContratController($stateParams, $uibModal, $window, $translate, entity, DevisContrat, AlertService, Principal) {
        var vm = this;

        vm.contrat = entity;
        vm.idContrat = $stateParams.id;
        vm.canEdit = false;
        vm.devisList = [];

        vm.load = load;
        vm.openCreate = openCreate;
        vm.openView = openView;
        vm.openEdit = openEdit;
        vm.downloadPdf = downloadPdf;
        vm.transform = transform;
        vm.statusLabelKey = statusLabelKey;
        vm.canEditQuote = canEditQuote;
        vm.canTransform = canTransform;
        vm.canDownloadPdf = canDownloadPdf;
        vm.editActionLabelKey = editActionLabelKey;
        vm.isContractClosed = isContractClosed;

        Principal.identity().then(function(account) {
            if (!account) {
                return;
            }
            vm.canEdit = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                || account.authorities.indexOf('ROLE_ADMIN') !== -1;
        });

        load();

        function load() {
            DevisContrat.query(vm.idContrat).then(function(result) {
                vm.devisList = result;
            }, handleError);
        }

        function openCreate() {
            if (!vm.canEdit || isContractClosed()) {
                return;
            }
            openDialog(null, 'edit');
        }

        function openView(devis) {
            if (!devis || !devis.id) {
                return;
            }
            openDialog(devis.id, 'view');
        }

        function openEdit(devis) {
            if (!canEditQuote(devis)) {
                return;
            }
            openDialog(devis.id, devis.etat === 'DRAFT' ? 'edit' : 'status');
        }

        function openDialog(devisId, mode) {
            $uibModal.open({
                templateUrl: 'app/business/contrat/devis-dialog.html',
                controller: 'DevisDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowClass: 'devis-modal-xl',
                resolve: {
                    contract: function() {
                        return vm.contrat;
                    },
                    devisId: function() {
                        return devisId;
                    },
                    readOnly: function() {
                        return mode === 'view';
                    },
                    mode: function() {
                        return mode;
                    }
                }
            }).result.then(function() {
                load();
            });
        }

        function downloadPdf(devis) {
            if (!canDownloadPdf(devis)) {
                return;
            }
            DevisContrat.downloadPdf(vm.idContrat, devis.id).then(function(result) {
                var defaultFileName = $translate.instant('wamasysApp.contrat.quote.defaultPdfFileName');
                var fileName = result.fileName || ((devis.referenceDevis || defaultFileName) + '.pdf');
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, handleError);
        }

        function transform(devis) {
            if (!canTransform(devis)) {
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.contrat.quote.confirmTransform'))) {
                return;
            }
            DevisContrat.transform(vm.idContrat, devis.id).then(function() {
                AlertService.success($translate.instant('wamasysApp.contrat.quote.transformSuccess'));
                load();
            }, handleError);
        }

        function statusLabelKey(status) {
            return status ? 'wamasysApp.contrat.quote.status.' + status : '';
        }

        function canEditQuote(devis) {
            return vm.canEdit
                && !isContractClosed()
                && devis
                && devis.etat !== 'TRANSFORMED';
        }

        function canTransform(devis) {
            return vm.canEdit
                && !isContractClosed()
                && devis
                && devis.id
                && devis.etat !== 'TRANSFORMED'
                && devis.etat !== 'REFUSED'
                && devis.etat !== 'CANCELLED';
        }

        function canDownloadPdf(devis) {
            return !!(devis
                && devis.id
                && devis.etat !== 'DRAFT'
                && devis.referenceDevis
                && devis.pdfPath);
        }

        function editActionLabelKey(devis) {
            return devis && devis.etat === 'DRAFT'
                ? 'wamasysApp.contrat.quote.editAction'
                : 'wamasysApp.contrat.quote.changeStateAction';
        }

        function isContractClosed() {
            return vm.contrat && vm.contrat.etat === 'CLOSED';
        }

        function handleError(error) {
            AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalError')));
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
